import React, { FC } from 'react';
import styles from './CountdownItem.module.scss';

interface OwnProps {
  label: string;
  value: number;
  numbersColor?: string;
  labelColor?: string;
}

const CountdownItem: FC<OwnProps> = ({ numbersColor, labelColor, label, value }) => {
  return (
    <div className={styles.countdownNumbersBlock}>
      <span className={styles.countdownNumber} style={{ color: numbersColor }}>
        {value}
      </span>
      <span className={styles.countdownNumberTitle} style={{ color: labelColor }}>
        {label}
      </span>
    </div>
  );
};

export default CountdownItem;
